import React from 'react';
import kisokuWebsiteTitle from 'assets/images/kisoku_web_title.png';
import logo from 'assets/images/daidolife_logo_original.png';
import LandingFooter, { FooterLink } from 'components/landing/LandingFooter';
import { Outlet, useLocation } from 'react-router-dom';
import TopLandingHeader from 'components/common/TopLandingHeader';
import SubHeader from 'components/common/SubHeader';
import LandingNavbar from 'components/landing/LandingNavbar';
import { useStyle } from 'lib/utils';
import SystemNotification from 'components/common/SystemNotification';

const footerLinks: FooterLink[] = [
    {
        url: '/kisoku/privacy-policy',
        title: '個人情報取扱規約 ',
    },
    {
        url: '/kisoku/terms-of-service',
        title: '利用規約',
    },
    {
        url: '/kisoku/inquiries',
        title: 'Q&A',
    },
];

type Props = {
    onOpenLoginModal: () => void,
}

const WorkRegulationLayout = (props: Props) => {
    const { onOpenLoginModal } = props;
    useStyle('work-regulation');
    const location = useLocation();

    const getTitle = () => {
        switch (location.pathname) {
            case '/kisoku/privacy-policy':
                return '個人情報取扱規約';
            case '/kisoku/terms-of-service':
                return '利用規約';
            case '/kisoku/inquiries':
                return 'Q&A';
            default:
                return '';
        }
    };

    const displayWebsiteTitle = () => {
        if (location.pathname.includes('/kisoku/')) {
            return '就業規則診断オンラインサービス';
        }

        return '公的支援オンラインサービス／就業規則診断オンラインサービス';
    };

    const Header = () => {
        switch (location.pathname) {
            case '/kisoku':
                return <TopLandingHeader image={kisokuWebsiteTitle} />;
            default:
                return <SubHeader title={getTitle()} />;
        }
    };

    return (
        <>
            <SystemNotification />
            <LandingNavbar onOpenLoginModal={onOpenLoginModal} websiteTitle={displayWebsiteTitle()} />
            <Header />
            <Outlet />
            <LandingFooter links={footerLinks} logo={logo} websiteTitle={displayWebsiteTitle()} />
        </>
    );
};

export default WorkRegulationLayout;
